export const getDisplayName = WrappedComponent => {
	return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};



// WEBPACK FOOTER //
// ./src/utils/getDisplayName.js